import React, { useRef, useContext, useState, useEffect, useCallback } from "react";
import pencil from "../../assets/pencil.png";
import trash from "../../assets/trash.png";
import printer from "../../assets/Printer.png";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import LogicContext from "../../Context/LogicContext";
import { SetWareHouseEdit } from "../../store/warehouseAtom";
import { Dropdown } from 'react-bootstrap';
import { stockTransferService } from "../../services/stockTransferService";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import { wareHouseService } from "../../services/warehouse.service";
import WareHouseScroll from "./WareHouseScroll";

const WareHouseDetailsPage = () => {
  const [selectedList, setSelectedList] = useState([]);
  const myPromiseModal = createModal(GeneralModal);
  const setStockTransferEdit = SetWareHouseEdit();

  const { id } = useParams();
  const navigate = useNavigate();
  const logicContext = useContext(LogicContext);
  const [wareHouseDetails, setWareHouseDetails] = useState({});

  const { pathname } = useLocation();
  const printRef = useRef(null);

  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    document.title = "WareHouse Details";
    let isMounted = true;

    if (isMounted) {
      loadDetailsData();
    }

    return () => {
      isMounted = false;
    };
  }, [id]);

  const loadDetailsData = () => {
    wareHouseService.wareHouseDetails(id).then((response) => {
      if (response.data?.warehouse?.length) {
        setWareHouseDetails(response.data.warehouse[0]);
      }
    });
  }

  const editCurrentData = async () => {
    const response = await myPromiseModal({
      title: "Modify Warehouse information",
      body: "Do you want to modify this record?",
      showInput: false,
    });

    if (response.decision === true) {
      setStockTransferEdit(wareHouseDetails);
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
    }
  };

  async function bulkActionsSingle(action) {
    const option = action.action_option;
    const result = await myPromiseModal({
      title: 'confirm your action!',
      body: `Do you want to ${action.status_name} ?`,
      showInput: false,
      placeHolder: '',
    });
    if (result.decision === false) {
      return;
    }

    try {
      const payload = { option: option, ref_no: id }
      const res = await stockTransferService.stockTransferAction(payload);
      const response = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);

      if (response.message_id === 1) {
        logicContext.showToast(response.message_text || ' successfully!', 'success');
        loadDetailsData();
      } else {
        logicContext.showToast(response.message_text || 'Failed to save', 'error');
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `Warehouse_${wareHouseDetails?.warehouse_id}`,
    onAfterPrint: () => console.log("Printed successfully"),
  });

  const onSelection = (list) => {
    const tempList = list?.filter((item) => item.checked === true);
    setSelectedList(tempList);
  };

  const getStatusColor = (statusName, statusId) => {
    switch (statusId) {
      case 4:
        return "bg-green-100 text-green-700";
      case 3:
        return "bg-yellow-100 text-yellow-700";
      case 2:
        return "bg-blue-100 text-blue-700";
      case 1:
        return "bg-red-100 text-red-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  const viewItemDetails = useCallback(
    adId => {
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${adId}`);
    },
    [currModuleId, currModuleName, navigate]
  );

  return (
    <section className="mt-4 w-full mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex justify-end gap-3 mb-6">
        {/* {stockTransferDetails?.action_status?.length > 0 && 
          <Dropdown>
            <Dropdown.Toggle
              className="text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-lg transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              id="dropdown-basic"
            >
              ACTION
            </Dropdown.Toggle>
            <Dropdown.Menu className="mt-2 shadow-lg border border-gray-200 rounded-md bg-white divide-y divide-gray-100">
              {stockTransferDetails?.action_status?.map((option, i) => (
                <Dropdown.Item 
                  key={i} 
                  onClick={() => bulkActionsSingle(option)} 
                  className="hover:bg-gray-100 py-2 px-4 text-sm text-gray-700 cursor-pointer"
                >
                  {option?.status_name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        } */}

        <button
          onClick={handlePrint}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          <img src={printer} alt="Print" className="w-5 h-5" />
          <span className="hidden sm:inline text-sm font-medium">Print</span>
        </button>

        <button
          onClick={editCurrentData}
          className="p-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition duration-200 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2"
          title="Edit"
        >
          <img src={pencil} alt="Edit" className="w-6 h-6" />
        </button>

        <button
          // onClick={deleteCurrentData}  ← uncomment when delete logic is ready
          className="p-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition duration-200 opacity-50 cursor-not-allowed"
          title="Delete (not implemented)"
        >
          <img src={trash} alt="Delete" className="w-6 h-6" />
        </button>
      </div>

      <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
        {/* Left Sidebar - Scroll List */}
        <div className="w-full lg:w-1/4 bg-white shadow-md rounded-xl overflow-hidden">
          <WareHouseScroll onSelection={onSelection} viewItemDetails={viewItemDetails} />
        </div>

        {/* Main Details Card - PRINTABLE AREA */}
        <div ref={printRef} className="flex-1 bg-white shadow-xl rounded-xl overflow-hidden ring-1 ring-gray-200">
          <div className="p-6 lg:p-8">
            {/* Header */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b border-gray-200 pb-4 mb-6">
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Warehouse Details</h1>
                <p className="text-sm text-gray-500 mt-1">
                  Ref No: {wareHouseDetails?.warehouse_id }
                </p>
              </div>
              <span
                className={`mt-3 sm:mt-0 px-4 py-1.5 rounded-full text-sm font-medium ${getStatusColor(
                  wareHouseDetails?.warehouse_status, 
                  wareHouseDetails?.warehouse_id
                )}`}
              >
                {wareHouseDetails?.warehouse_status || "—"}
              </span>
            </div>

            {/* Warehouse Information */}
            <div className="space-y-8">
              <div>
                <h2 className="text-lg font-medium text-gray-900">Basic Information</h2>
                <dl className="mt-4 grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2">
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Warehouse Name</dt>
                    <dd className="mt-1 text-sm text-gray-900">{wareHouseDetails?.warehouse_name || "—"}</dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Contact Person</dt>
                    <dd className="mt-1 text-sm text-gray-900">{wareHouseDetails?.warehouse_contact_person || "—"}</dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Contact Number</dt>
                    <dd className="mt-1 text-sm text-gray-900">{wareHouseDetails?.warehouse_contact_number || "—"}</dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Email Address</dt>
                    <dd className="mt-1 text-sm text-gray-900">{wareHouseDetails?.warehouse_email_address || "—"}</dd>
                  </div>
                  <div className="sm:col-span-2">
                    <dt className="text-sm font-medium text-gray-500">Address</dt>
                    <dd className="mt-1 text-sm text-gray-900">{wareHouseDetails?.warehouse_address || "—"}</dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Latitude</dt>
                    <dd className="mt-1 text-sm text-gray-900">{wareHouseDetails?.warehouse_latitude ?? "—"}</dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Longitude</dt>
                    <dd className="mt-1 text-sm text-gray-900">{wareHouseDetails?.warehouse_longitude ?? "—"}</dd>
                  </div>
                </dl>
              </div>

              <div>
                <h2 className="text-lg font-medium text-gray-900">Audit Information</h2>
                <dl className="mt-4 grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2">
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">C Code</dt>
                    <dd className="mt-1 text-sm text-gray-900">{wareHouseDetails?.c_code || "—"}</dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Encoded By</dt>
                    <dd className="mt-1 text-sm text-gray-900">{wareHouseDetails?.encoded_by || "—"}</dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Encoded Date</dt>
                    <dd className="mt-1 text-sm text-gray-900">
                      {wareHouseDetails?.encoded_date ? formatCustomDate(wareHouseDetails.encoded_date) : "—"}
                    </dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Last Changed By</dt>
                    <dd className="mt-1 text-sm text-gray-900">{wareHouseDetails?.last_changed_by || "—"}</dd>
                  </div>
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">Last Changed Date</dt>
                    <dd className="mt-1 text-sm text-gray-900">
                      {wareHouseDetails?.last_changed_date ? formatCustomDate(wareHouseDetails.last_changed_date) : "—"}
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
       
          </div>
        </div>
      </div>
    </section>
  );
};

export default WareHouseDetailsPage;